import { NarrativeCommunityHeaderInfoBlock } from './NarrativeCommunityHeaderInfoBlock';
import InfoValuator from '../images/info-valuator.svg';
import InfoAlert from '../images/info-alert.svg';
import InfoDiscussion from '../images/info-discussion.svg';

type Props = {
  title: string | undefined | null;
  hasBreadcrumbs: boolean;
};

export const NarrativeCommunityDefaultHeader = ({
  title,
  hasBreadcrumbs,
}: Props) => {
  return (
    <div className="mt-2">
      {hasBreadcrumbs && (
        <h1 className="m-0 mb-1 text-xl font-bold [word-break:break-word]">
          {title}
        </h1>
      )}
      <p className="text-soft">
        Our community narratives are driven by numbers and valuation.
      </p>
      <div role="list" className="grid justify-between gap-x1 lg:grid-cols-3">
        <NarrativeCommunityHeaderInfoBlock
          icon={<InfoValuator width="100%" height="100%" />}
        >
          Value any stock for free in seconds
        </NarrativeCommunityHeaderInfoBlock>
        <NarrativeCommunityHeaderInfoBlock
          icon={<InfoAlert width="100%" height="100%" />}
        >
          Get alerts and valuation updates
        </NarrativeCommunityHeaderInfoBlock>
        <NarrativeCommunityHeaderInfoBlock
          icon={<InfoDiscussion width="100%" height="100%" />}
        >
          Participate in discussions
        </NarrativeCommunityHeaderInfoBlock>
      </div>
    </div>
  );
};
